import { useLocation, useNavigate } from "react-router-dom";
import { UpgradeModal } from "../Profile/modal/UpgradeModal";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { analyticsEvent } from "../../redux/actions/analytics";

export interface CheckoutProps {
  url: string;
  price: string;
  additionalText: string;
  title: string;
  isFromExistingUser: boolean;
  isHardware: boolean;
  cancelUrl?: string;
  couponCode?: string; // Add the couponCode property
}

export const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Initialize useDispatch
  const { url, price, additionalText, title, cancelUrl, couponCode }: CheckoutProps =
    location.state || {};
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    if (!location.state?.url) {
      navigate("/");
    }
    previousPath.current = document.referrer;
  }, [location, navigate]);

  useEffect(() => {
    if (url && url.includes("rto")) { // Assuming "rto" in URL indicates RTO plan
      dispatch(
        analyticsEvent("PAGE_VISIT", "Rent to Own Checkout Started", {
          page: "Checkout Page",
          plan_details: title, // Using title as plan_details for now
        }),
      );
    }
  }, [url, dispatch, title]);

  const goBack = () => {
    console.log("cancelUrl", cancelUrl);
    if (cancelUrl) {
      navigate(cancelUrl);
    } else {
      if (
        previousPath.current &&
        !previousPath.current.includes(location.pathname)
      ) {
        navigate(previousPath.current);
      } else {
        navigate("hardware");
      }
    }
  };

  return (
    <div>
      <UpgradeModal
        error=""
        title={title}
        url={url}
        open={true}
        handleClose={goBack}
        price={price}
        additionalText={additionalText}
        couponCode={couponCode}
      />
    </div>
  );
};
